export function isFootprintCoverageBlockingNewSpaces(
  isHybrid: boolean,
  isFullyCovered: boolean
): boolean {
  return !isHybrid && isFullyCovered;
}
